import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Primary client used throughout the app (AuthContext, queries, etc.).
// Persist and refresh the session so browser reloads do not force the
// user back to the login screen. Inactivity-based logout is handled
// separately in AuthContext.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
})

// Lightweight in-memory storage so that auth state for the secondary client
// does not persist to localStorage or interfere with the primary client's
// session. This prevents admin signUp operations from switching the active
// browser session.
const memoryStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
}

// Secondary client used only for programmatic user creation (signUp) so
// that creating a new user does not change the currently logged-in admin
// session in the main client.
export const supabaseBackgroundAuth = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: memoryStorage,
    persistSession: false,
    autoRefreshToken: false,
  },
})
